import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cd1cac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tyres_patterns" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "PROPRIETARY BRAND", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw_500" }, " Stamford Sport Wheels, or SSW, is our proprietary brand of alloy wheels. Our wheels are designed, manufactured and tested in-house. Our designers have created a line of wheels that offer exciting style, looks and road performance. SSW has models with diameters of 13” to 26” tailored for passenger cars and SUVs. Our wheels are produced in Thailand using the latest low pressure and tilt gravity casting methods and in accordance with internationally recognized quality and safety standards. ", -1))
const _hoisted_8 = { class: "d-inline-flex flex-wrap gap-2" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: { path: '/ssw-wheels' , hash: '#wheelBrands'},
                class: "btn red_btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("VIEW SSW WHEELS")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { path: '/diesel-wheels' , hash: '#wheelBrands'},
                class: "btn red_btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("VIEW DIESEL WHEELS")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { path: '/flotec-wheels' , hash: '#wheelBrands'},
                class: "btn red_btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("VIEW FLOTEC WHEELS")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}